"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isUniqueIn(array) {
    return (value) => array.filter((el) => el === value).length === 1;
}
/**
 * Returns an array of which all elements only exists in one of two arrays.
 * Same as the xor operation.
 *
 * @Param {a} = The first array to use.
 * @Param {b} = The second array to use.
 *
 * @Example
 *
 *    symmetricDifference([1, 2], [2, 3]);
 *    //=> [1, 3]
 *
 *    symmetricDifference([1, 2], [3, 4]);
 *    //=> [1, 2, 3, 4]
 */
function symmetricDifference(a, b) {
    const concatinated = a.concat(b);
    return concatinated.filter(isUniqueIn(concatinated));
}
exports.symmetricDifference = symmetricDifference;
//# sourceMappingURL=symmetric-difference.js.map